<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
      <img class="float-left display-3 mr-4" :src="logo" alt="logo-symbol">
    </b-row>
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">404</h1>
            <h4 class="pt-3">Oops! Não encontrado.</h4>
            <p class="text-muted">A pagina solicitada não foi encontrada.</p>
          </div>
          <!--
          <b-input-group>
            <b-input-group-prepend>
              <b-input-group-text>
                <i class="fa fa-search"></i>
              </b-input-group-text>
            </b-input-group-prepend>
            <input id="prependedInput" class="form-control" size="16" type="text" placeholder="What are you looking for?">
            <b-input-group-append>
              <b-button variant="info">Search</b-button>
            </b-input-group-append>
          </b-input-group>
          -->
          <b-row class="justify-content-center">
              <b-button variant="info" @click.stop.prevent="voltar()">
                  <i class="fa fa-arrow-left"></i> Voltar
              </b-button>    
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page404',
  data() {
    return {
      logo: require('../../../static/img/logo-symbol.png')
    }
  },
  methods: {
    voltar() {
      const ultimaRota = window.localStorage.getItem('ultimaRota')
      if (ultimaRota) {
        this.$router.push(ultimaRota)
      } else {
        this.$router.push('/')
      }
    }
  },
  created() {
    this.$store.commit('controle/setAguardando', false)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/pages/Page404.vue